import React from "react";
import { PageTitle } from "../../PageTitle";
import SoftwarePageTemplate, {
  Feature,
  SoftwareSlide,
} from "../SoftwarePageTemplate/SoftwarePageTemplate";
import {
  IconCalculator,
  IconTemperature,
  IconBlock,
  IconInstallation,
  IconImport,
  IconMeasure,
  IconBrowser,
  IconHeadphones,
} from "../../assets/icons/Icon";
import hydraulicCalc from "./pictures/hydraulic-calculations.png";
import model3D from "./pictures/model3d.png";
import labConnection from "./pictures/lab-connection.jpg";
import recalcModule from "./pictures/recalc-module.png";

const slides: SoftwareSlide[] = [
  {
    image: hydraulicCalc,
    alt: "Интерфейс модуля гидравлических расчетов CemLife",
    title: "Гидравлические расчеты",
    description: `Модуль включает расчет зависимости давлений от глубины, который позволяет определить «зону интереса» по ГРП; расчет ЭЦП, позволяющий точно подобрать расходы для лучшего вытеснения и недопуска ГРП, и множество других расчетов.`,
  },
  {
    image: model3D,
    alt: "Интерфейс модуля 3D вытеснения бурового раствора CemLife",
    title: "3D вытеснение бурового раствора",
    description: `Наиболее точный алгоритм расчета 3D вытеснения в отрасли помогает проанализировать и предотвратить каналообразование. График концентрации жидкостей в зоне интереса позволяет поставить тесты на совместимость для понимания реального состояния жидкостей в скважине.`,
  },
  {
    image: labConnection,
    alt: "Интерфейс модуля связи с лабораторным ПО CemTest",
    title: "Связь с лабораторной системой CemTest",
    description: `CemLife поддерживает интеграцию следующих данных: реологические показания, время загустевания, тесты на совместимость. Тесная связь также позволяет создать затарочный лист и техническое задание для цементного завода. Использование данного модуля значительно сокращает время подготовки кейса.`,
  },
  {
    image: recalcModule,
    alt: "Интерфейс модуля перерасчета CemLife",
    title: "Модуль перерасчет",
    description: `Предоставляет инструменты детального анализа проведенной работы по реальным данным со скважины. Позволит повысить качество цементирования на будущих работах.`,
  },
];

const features: Feature[] = [
  {
    name: "Расчет центрации",
    icon: IconCalculator,
    text: "Расчет центрации в месте установки центраторов и между ними с учетом прогиба трубы. Максимальная точность расчетов на основе данных с тестов центраторов согласно API 10D.",
  },
  {
    name: "Термодинамический расчет температуры",
    icon: IconTemperature,
    text: "Современный алгоритм термодинамического расчета температуры позволяет более точно подобрать техническое задание для лаборатории.",
  },
  {
    name: "Крутящий момент и сопротивление",
    icon: IconBlock,
    text: "Программа помогает определить риски недохождения обсадной колонны до проектного забоя и рассчитать возможность ее вращения при цементировании с учетом реальных параметров.",
  },
  {
    name: "Установка мостов",
    icon: IconInstallation,
    text: "Программный комплекс поддерживает расчет установки цементных мостов на баланс.",
  },
  {
    name: "Импорт кавернометрии",
    icon: IconImport,
    text: "Возможность импорта кавернометрии позволяет добиться более точных расчетов по 3D вытеснению.",
  },
  {
    name: "Сравнение кейсов",
    icon: IconMeasure,
    text: "Программа предоставляет возможность сравнить несколько результатов расчетов при разных параметрах.",
  },
  {
    name: "Понятный интерфейc",
    icon: IconBrowser,
    text: "Интуитивно понятный интерфейс, который делает процесс работы с приложением максимально комфортным и эффективным.",
  },
  {
    name: "Техническая поддержка",
    icon: IconHeadphones,
    text: "Постоянно обновляющаяся техническая поддержка, гарантирующая бесперебойную работу Ваших инженеров.",
  },
];

const CemLife: React.FC = () => {
  return (
    <>
      <PageTitle title="CemLife — Интеллект-Развитие-Технологии" />
      <SoftwarePageTemplate
        key="cemlife"
        id="cemlife"
        title="cemlife"
        subtitle={`Программное обеспечение\nдля расчетов при цементировании нефтегазовых скважин`}
        cardText="Разработано при участии инженеров высочайшего класса — каждый модуль проверен на реальных кейсах, а не только в лаборатории."
        accentText1="CemLife позволяет учесть возможные инциденты при сооружении нефтегазовых скважин и предотвратить вероятность их возникновения."
        accentText2="Программа заранее подсвечивает зоны риска и помогает подобрать оптимальные решения, чтобы Вы исключили аварийные ситуации ещё на этапе проектирования."
        moduleSubheader="CemLife состоит из нескольких модулей, обеспечивающих всесторонний анализ факторов риска, максимальную точность расчетов и надежность Вашего проектирования."
        slides={slides}
        features={features}
      />
    </>
  );
};

export default CemLife;
